import { DataType } from '../../DataType';
import { FFuncScalar } from '../FormulaFunc';
export class LOG extends FFuncScalar {
    constructor(args) {
        super('LOG', args);
    }
    getReturnType(argTypes) {
        return DataType.FLOAT;
    }
    value(scope, ...args) {
        return Math.log(args[0](scope));
    }
}
